import request from "../helpers/request";
import helpers from "../helpers/common";

const merchants = {}

merchants.init = async () => {
    return request.get('/init')
}

merchants.getData = (filters = {}) => {
    return request.get('/merchants', filters, true)
}
merchants.paymentsAccess = () => {
    return request.get('/merchants/payments-access', {}, true)
}
merchants.list = (filters = {}) => {
    return request.get('/merchants/list', filters, true)
}
merchants.get = (uuid) => {
    return request.get('/merchants/get', {uuid}, true)
}

merchants.add = async (data) => {
    return request.post('/merchants/add', data, true)
}

merchants.edit = async (data) => {
    return request.put('/merchants/edit', data, true)
}

merchants.login = async (username, password) => {
    return request.post('/merchants/login', {username, password}, true)
}

merchants.logout = async () => {
    await request.post('/merchants/logout', {}, true)
    //window.location.href = '/'
}

merchants.addMerchant = async (data) => {
    return request.post('/merchants/add', {...data, type: 'm'}, true)
}

merchants.forgotPassword = async (email, type = 'm') => {
    return request.post('/merchants/forgot-password', {email, type}, true)
}

/** GET remaining daily limit for merchant of this customer. customer = customer uuid (32 chars). */
merchants.getRemainingDaily = (customerUuid) => {
    return request.get('/merchants/remaining-daily', { customer: customerUuid }, true)
}

/** GET validate if link amount is within remaining daily limit. amount = subunit amount, currency = e.g. EUR. */
merchants.validateLinkAmount = (customerUuid, amount, currency) => {
    return request.get('/merchants/validate-link-amount', { customer: customerUuid, amount: String(amount), currency }, true)
}

/** GET currencies allowed for this customer's merchant (EUR/USD + merchant extra). */
merchants.getAllowedCurrencies = (customerUuid) => {
    return request.get('/merchants/allowed-currencies', { customer: customerUuid }, true)
}

merchants.methodValidator = {}
merchants.methodValidator.add = (fields, errors = {}) => {
    merchants.fieldValidator.username(fields, errors)
    merchants.fieldValidator.password(fields, errors)
    merchants.fieldValidator.name(fields, errors)
    if (typeof merchants.fieldValidator.max_daily_volume === 'function') merchants.fieldValidator.max_daily_volume(fields, errors)
    if (typeof merchants.fieldValidator.checkout_mode === 'function') merchants.fieldValidator.checkout_mode(fields, errors)
    if (fields.referral_id) {
        const pct = parseFloat(fields.referral_percentage);
        if (isNaN(pct) || pct < 0 || pct > 100) {
            errors.referral_percentage = 'Percentage should be between 0 and 100';
        }
    }
    return errors
}
merchants.methodValidator.edit = (fields, errors = {}) => {
    merchants.fieldValidator.username(fields, errors)
    fields.password && merchants.fieldValidator.password(fields, errors)
    merchants.fieldValidator.name(fields, errors)
    if (typeof merchants.fieldValidator.max_daily_volume === 'function') merchants.fieldValidator.max_daily_volume(fields, errors)
    if (typeof merchants.fieldValidator.checkout_mode === 'function') merchants.fieldValidator.checkout_mode(fields, errors)
    return errors
}

merchants.fieldValidator = {}
merchants.fieldValidator.username = (fields, errors) => {
    helpers.emailValidator(fields, errors, 'username')
}
merchants.fieldValidator.password = (fields, errors) => {
    helpers.passwordValidator(fields, errors)
}
merchants.fieldValidator.name = (fields, errors) => {
   if (!fields.name || fields.name.length < 3) return errors.name = 'Name should be at least 3 characters'
    fields.name = fields.name.trim()
}
merchants.fieldValidator.max_daily_volume = (fields, errors) => {
    if (fields.max_daily_volume === '' || fields.max_daily_volume == null) return
    const v = parseFloat(fields.max_daily_volume)
    if (isNaN(v) || v < 0) errors.max_daily_volume = 'Must be 0 or greater'
}
merchants.fieldValidator.checkout_mode = (fields, errors) => {
    if (!fields.checkout_mode) return
    const allowed = ['redirect_checkout', 'onsite_s2s']
    if (!allowed.includes(fields.checkout_mode)) {
        errors.checkout_mode = 'Invalid checkout mode'
    }
}

export default merchants